import { resolveCaseStatusValue, resolveMediaRecordStatusValue } from './statusNormalization';
import { formatMessage, UiMessages } from '../uiMessages';

export function formatCaseStatusLabel(value) {
  const normalized = resolveCaseStatusValue(value);
  if (!normalized) {
    return 'Unknown status';
  }

  if (normalized === 'active') {
    return 'Active';
  }

  if (normalized === 'archived') {
    return 'Archived';
  }

  if (normalized === 'retrieved') {
    return 'Retrieved';
  }

  if (normalized === 'archiving') {
    return 'Archiving';
  }

  if (normalized === 'retrieving') {
    return 'Retrieving';
  }

  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function getCaseUploadBlockedMessage(caseTitle, caseStatus) {
  const resolvedCaseTitle = String(caseTitle || '').trim() || 'Case';
  return formatMessage(UiMessages.caseUploadBlocked, {
    caseTitle: resolvedCaseTitle,
    caseStatus: formatCaseStatusLabel(caseStatus)
  });
}

export function formatMediaRecordStatusLabel(value) {
  const normalized = resolveMediaRecordStatusValue(value);
  if (!normalized) {
    return 'Unknown status';
  }

  if (normalized === 'submitted') {
    return 'Submitted';
  }

  if (normalized === 'retrieved') {
    return 'Retrieved';
  }

  if (normalized === 'draft') {
    return 'Draft';
  }

  if (normalized === 'deleted') {
    return 'Deleted';
  }

  if (normalized === 'unsubmitted') {
    return 'Unsubmitted';
  }

  if (normalized === 'archived') {
    return 'Archived';
  }

  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export function getPlaybackUnavailableMessage(mediaFileName, mediaStatus) {
  const resolvedMediaFileName = String(mediaFileName || '').trim() || 'Media file';
  return formatMessage(UiMessages.playbackUnavailable, {
    mediaFileName: resolvedMediaFileName,
    mediaStatus: formatMediaRecordStatusLabel(mediaStatus)
  });
}
